import React, {useEffect, useState} from 'react';
import "./faq.css"
import CustomizedTables from "../table/table";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
const Faq = (props) => {
    const [question , setQuestion] = useState("")
    const [answer , setAnswer] = useState( "")
    const [list , setList] = useState(props?.answer ?? [])

    useEffect(()=>{
        props?.answer && setList(props?.answer)
    },[props?.answer])

    const onDelete = (e) => {
        let arr = [...list]
        arr.splice(e , 1)
        setList(arr)
    }
    const handleFaq =async (e) => {
        let newList = [...list , {question: question , answer:answer}]
        setList(newList)
        setQuestion("")
        setAnswer("")
        props.onChange(newList)
    }
    return (

        <div>
            {
                <Grid style={{margin:"0 0 50px 0"}} alignItems={"center"} container xs={12}>
                    <Grid item xs={12}>
                        <TextField
                            label="سوال"
                            variant="outlined"
                            margin='normal'
                            value={question}
                            fullWidth
                            multiline
                            rows={2}
                            name='headTitle'
                            onChange={(e) => setQuestion(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            multiline
                            rows={2}
                            disabled={!question}
                            label="پاسخ"
                            variant="outlined"
                            margin='normal'
                            value={answer}
                            fullWidth
                            name='answer'
                            onChange={(e) => setAnswer(e.target.value)}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <Button onClick={(e) => {handleFaq(e)}}  disabled={!question || !answer}  margin='desc' variant='contained' color='primary'> افزودن</Button>
                    </Grid>
                    <CustomizedTables keyItem = {"پاسخ"} title = {"سوال"} data = {list} onDelete = {(e) => {onDelete(e)}}/>
                </Grid>
            }
        </div>
    );
};

export default Faq;